<div class="bucket-item" #itemElement>
  <ng-content></ng-content>
</div>
